var map = {
	"./KEEPAWAY.svg": [
		68699,
		8699
	],
	"./KEEPAWAY33.svg": [
		34701,
		4701
	],
	"./KEEPAWAY44.svg": [
		84379,
		4379
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 60640;
module.exports = webpackAsyncContext;